var from = require("./_/index.js");

module.exports = from;
module.exports['__VERSION__'] = '1.0.13';